import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MenuBar from "./components/MenuBar";
import Footer from "./components/Footer";
import ScrollToTop from "../src/pages/ScrollToTop";  // Adjust the path as needed
import {
  Products,
  Home,
  Client,
  AdvancedMachinery,
  About,
  Services,
  Contact,
  Careers,
} from "./pages";
import "./App.css";

function App() {
  return (
    <Router>
      {/* ScrollToTop must be directly inside Router to catch route changes */}
      <ScrollToTop />
      <MenuBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/advanced-machinery" element={<AdvancedMachinery />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/client" element={<Client />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<Careers />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
